export const swiper = "bg-white dark:bg-gray-700 py-2 text-center";
export const container = "flex items-center justify-center align-middle"
export const dimencion = " box-content h-xl w-96 mb-5 shadow-md rounded-lg"
export const img ="mb-4 w-full h-full rounded"